const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-viewcollections'] = {
        c: () => require('partner/modules/moe-viewcollections/moe-viewcollections.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-viewcollections',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-viewcollections'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-viewcollections|moe-viewcollections'] = {
                c: () => require('partner/modules/moe-viewcollections/moe-viewcollections.view.tsx'),
                cn: '__local__-__local__-moe-viewcollections'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };